var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
export var API_BASE = '/api/chrome-service/v1';
export var LAST_VISITED_URL = "".concat(API_BASE, "/last-visited");
export var FAVORITE_PAGE_URL = "".concat(API_BASE, "/favorite-pages");
export var IDENTITY_URL = "".concat(API_BASE, "/user");
export var VISITED_BUNDLES_URL = "".concat(API_BASE, "/user/visited-bundles");
function fetchWrapper(url, options) {
    var _this = this;
    return fetch(url, options).then(function (res) { return __awaiter(_this, void 0, void 0, function () {
        var clone, isJson, error, _a;
        var _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    if (!!res.ok) return [3, 5];
                    clone = res.clone();
                    isJson = (_b = clone.headers.get('content-type')) === null || _b === void 0 ? void 0 : _b.includes('application/json');
                    if (!isJson) return [3, 2];
                    return [4, clone.json()];
                case 1:
                    _a = _c.sent();
                    return [3, 4];
                case 2: return [4, clone.text()];
                case 3:
                    _a = _c.sent();
                    _c.label = 4;
                case 4:
                    error = _a;
                    throw error;
                case 5: return [2, res.json()];
            }
        });
    }); });
}
export function get(url, options) {
    return fetchWrapper(url, __assign(__assign({}, options), { method: 'GET' })).then(function (_a) {
        var data = _a.data;
        return data;
    });
}
export function post(url, data, options) {
    return fetchWrapper(url, __assign(__assign({ credentials: 'include' }, options), { headers: __assign(__assign({}, options === null || options === void 0 ? void 0 : options.headers), { 'Content-Type': 'application/json' }), method: 'POST', body: JSON.stringify(data) })).then(function (_a) {
        var data = _a.data;
        return data;
    });
}
//# sourceMappingURL=fetch.js.map